import { injectGlobal } from 'styled-components';

injectGlobal`
  html {
    font-size: 16px;
    box-sizing: border-box;
  }

  * {
    margin: 0;
    padding: 0;
  }

  *, *:before, *:after {
    box-sizing: inherit;
  }

  body {
    font-family: 'Open Sans', sans-serif;
    -webkit-font-smoothing: antialiased;
  }
`;



// WEBPACK FOOTER //
// ./src/globalStyles.js